// src/contexts/AuthContext.jsx
import React, { createContext, useContext, useState, useEffect } from 'react'
import { SupabaseClient } from '../supabaseClient'

const AuthContext = createContext();

export function AuthProvider({ children }) {
    const [session, setSession] = useState(null)
    const [initialising, setInitialising] = useState(true)

    useEffect(() => {
        let isMounted = true
        let attempts = 0

        const fetchSession = async () => {
            while (attempts < 3) {
                attempts += 1
                try {
                    const { data, error } = await SupabaseClient.auth.getSession()
                    if (error) throw error
                    if (isMounted) {
                        setSession(data.session)
                        setInitialising(false)
                    }
                    return
                } catch (err) {
                    console.warn(`Auth session fetch failed (attempt ${attempts}):`, err)
                    // optionally add a small delay here before retrying
                }
            }
            // after 3 failed attempts
            if (isMounted) {
                console.error('Unable to fetch auth session after 3 attempts.')
                setInitialising(false)
            }
        }

        fetchSession()

        const {
            data: { subscription },
        } = SupabaseClient.auth.onAuthStateChange((_event, newSession) => {
            if (isMounted) {
                setSession(newSession)
            }
        })

        return () => {
            isMounted = false
            subscription.unsubscribe()
        }
    }, [])

    const logout = () => SupabaseClient.auth.signOut()

    return (
        <AuthContext.Provider
            value={{
                session,
                user: session?.user ?? null,
                initialising,
                logout,
            }}
        >
            {children}
        </AuthContext.Provider>
    )
}

// helper hook
export const useAuth = () => useContext(AuthContext)